import store from   './store'
import request from './requests'

var Utilities = {

    //set the token to localStorage
    setLocalStorage(storageName, data) {
        localStorage.setItem(storageName, data);
    },

    setRedirectToLocalStorage(data) {
        localStorage.setItem('redirectToken', JSON.stringify(data));
    },
    
    
    returnBookType(type) {
        if (type === 'Published') {
            return 'Σύγγραμμα'
        } else if (type === 'eBook') {
            return 'Ηλεκτρονικό Βιβλίο'
        } else if (type === 'ProfessorNotes') {
            return 'Δωρεάν Ηλεκτρονικό Βοήθημα / Σημειώσεις'
        } else if (type === 'UniversityPress') {
            return 'Πανεπιστημιακή Έκδοση'
        } else if (type === 'Free') {
            return 'Δωρεάν Βιβλίο'
        } else {
            return '--';
        }
    },
    
    getBindingTypeGreekString(bindingType) {
        let retv;
        
        switch (bindingType) {
            case 'Hard':
                retv = 'Σκληρό εξώφυλλο';
                break;
            case 'Soft':
                retv = 'Μαλακό εξώφυλλο';
                break;
            case 'Leather':
                retv = 'Δερματόδετο';
                break;
            case 'None':
                retv = 'Χωρίς';
                break;
            default:
                retv = 'ΑΛΛΟ';
                break;
        }
        
        return retv;
    },


// create book path
    reformatBookPath(path) {
        if (typeof path === 'string' && path.length > 0 && !path.startsWith('http')) {
            return   'https://static.eudoxus.gr/books/' + path
        } else {
            return path
        }
    },

    // need format yyyy/MM/dd
    // returns 1 if 1st date is greater than 2nd date -1 if 2nd is greater than 1st and 0 if equal
    compareDates(firstdate, secondDate) {
        const splitFirstDate = firstdate.split('-');
        const splitSecondDate = secondDate.split('-');

        const firstDateYear = Number(splitFirstDate[0]);
        const firstDateMonth = Number(splitFirstDate[1]);
        const firstDateDay = Number(splitFirstDate[2]);
        const secondDateYear = Number(splitSecondDate[0]);
        const secondDateMonth = Number(splitSecondDate[1]);
        const secondDateDay = Number(splitSecondDate[2]);

        if(firstDateYear>secondDateYear){
            return +1;
        }
        else if(firstDateYear<secondDateYear){
            return -1;
        }
        else {
            if(firstDateMonth>secondDateMonth){
                return +1;
            }
            else if(firstDateMonth<secondDateMonth){
                return -1;
            }
            else{
                if(firstDateDay>secondDateDay){
                    return +1;
                }
                else if(firstDateDay<secondDateDay){
                    return -1;
                }
                else
                    return 0;
            }

        }

    },


    //get the token from localStorage
    getLocalStorage(storageName) {
        return localStorage.getItem(storageName);
    },

    // delete the token from localStorage
    deleteLocalStorage(storageName) {
        localStorage.removeItem(storageName);
    },


    downLoadPDFNewTab(response){
        let blob = new Blob([response.data], {
            type: "application/pdf"
        });

        let url = window.URL.createObjectURL(blob);
        window.open(url,"_blank")

        //window.URL.revokeObjectURL(url);
    },

    checkIfNotEmptyUndefinedOrNull(val){
        if(val === '' || val == null || val == undefined) {
            return false;
        }else {
            return true;
        }
    },

    removeTokenFromBrowser() {
        this.deleteLocalStorage('cmt_token');
        let home = {
            eudoxusYears:[],
            pricingCommittee:{
                authorizationId:'',
                contactEmail:'',
                contactName:'',
                contactPhone:'',
                id:'',
                type:'',
            },
            token:''
        };
        store.commit('setHomePageInformation', home);
        store.commit('setLoginModal', true);
    },

    openErrorDialog(errorText) {
        var storeObj = {
            title: 'Σφάλμα!',
            text: errorText,
            color: 'error',
            class: 'white--text indianRed text-center justify-center'
        };
        store.commit('setErrorPopup', true);
        store.commit('setErrorPopupProps', storeObj);
    },

    createNavigationItem() {

        // check permisio and create the navigation Item
        var  navigationItems = [
            {id: 0, icon: 'home', label: 'Αρχική Σελίδα', link: '/', disabled: false},
            {id: 1, icon: 'mdi-book-open-variant', label: 'Συγγράμματα', link: '/books', disabled: false},
            {id: 2, icon:'mdi-eyedropper', label: 'Επιλογή Δείγματος', link: '/sampleSelection', disabled: false},
            {id: 3, icon: 'local_shipping', label: 'Παραλαβή Συγγραμμάτων', link: '/bookPickup', disabled: false},
            {id: 4, icon: 'euro_symbol', label: 'Διαχείριση Τιμών Κοστολόγησης', link: '/pricingManagement', disabled: false},
            {id: 5, icon:'mdi-code-tags', label: 'Διαχείριση Μηνυμάτων', link: '/mailTemplates', disabled: false},
        ];

        store.commit('setNavigationItems', navigationItems);
    },

    downLoadXLSX(response){

        let blob = new Blob([response.data], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet.main+xml"
        }); // 2. Get the blob setting file type in the response object returned by the request. Here is excel as an example.
        let url = window.URL.createObjectURL(blob); // 3. Create a temporary url pointing to the blob object

        // 4. After creating the url, you can simulate a series of operations on this file object, for example: preview, download
        let a = document.createElement("a");
        a.href = url;
        a.download = response.headers.filename;
        a.click();
        // 5. Release this temporary object url
        window.URL.revokeObjectURL(url);
    },

    downloadFile(type, filename, data){

        let blob = new Blob([data], {
            type: type
        }); // 2. Get the blob setting file type in the response object returned by the request. Here is excel as an example.
        let url = window.URL.createObjectURL(blob); // 3. Create a temporary url pointing to the blob object

        // 4. After creating the url, you can simulate a series of operations on this file object, for example: preview, download
        let a = document.createElement("a");
        a.href = url;
        // if(filename === '' || filename === null  || filename === undefined ){
        //     a.download = filename;
        // }else{
        //     a.download = filename;
        // }
        a.download = filename;
        a.click();
        // 5. Release this temporary object url
        window.URL.revokeObjectURL(url);
    },

    downloadReport(obj) {

        let token = this.getLocalStorage('cmt_token');
        if (token != null) {
            if (obj.format == 'pdf') {
                // request.downloadReport(obj, this.downLoadPDF);
            }
            else {
                request.downloadReport(obj, this.downLoadXLSX);
            }
        }
        else {
            store.commit('setLoginModal', true);
        }
    },


    setSuccessPopup(title, text){
        var errorProps = {
            title: title,
            text: text,
            color: 'teal',
            class: 'white--text teal text-center justify-center',
            icon:'success',
            successStyle:true
        };

        store.commit('setErrorPopup', true);
        store.commit('setErrorPopupProps', errorProps);
    },

    setErrorPopup(title, message){
        var errorProps = {
            title: title,
            text: message,
            color: 'indianRed',
            class: 'white--text indianRed text-center justify-center',
            icon:'error',
            successStyle:false
        };

        store.commit('setErrorPopup', true);
        store.commit('setErrorPopupProps', errorProps);
    },

};


export default Utilities
